module.exports = {
      id: "icon-headset-usage",
      viewBox: "0 0 14.219 15.009",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#icon-headset",
      toString: function () {
        return this.url;
      }
    }